import {
  Fade,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MenuIcon from "@mui/icons-material/Menu";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import CommitIcon from "@mui/icons-material/Commit";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

function CompetitionActions({
  competition,
  selectedTab,
  setCompetition,
  endCompetition,
  deleteCompetition,
  setIsRunCompetitionModalOpen,
  setIsParticipantModalOpen,
  activateCompetition,
  removeCompetitionFromFavorites,
}) {
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleCompetitionEnd = (event) => {
    endCompetition(competition);
    handleClose(event);
  };

  const handleCompetitionDelete = (event) => {
    deleteCompetition(competition);
    handleClose(event);
  };

  const handleRemoveCompetitionFromFavorites = (event) => {
    removeCompetitionFromFavorites(competition);
    handleClose(event);
  };

  const handleRunCompetition = (event) => {
    setIsRunCompetitionModalOpen(true);
    setCompetition(competition);
    handleClose(event);
  };

  const handleCompetitionAssign = (event) => {
    setIsParticipantModalOpen(true);
    setCompetition(competition);
    handleClose(event);
  };

  const handleCompetitionEdit = (event) => {
    navigate(`/compete/builder/edit/${competition.id}`);
    handleClose(event);
  };

  const handleCompetitionCopy = (event) => {
    navigate(`/compete/builder/copy/${competition.id}`);
    handleClose(event);
  };

  const handleCompetitionActivate = (event) => {
    activateCompetition(competition);
    handleClose(event);
  };

  return (
    <>
      <IconButton sx={{ p: 0 }} onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
        sx={{
          "& .MuiTypography-root ": {
            fontSize: "16px",
          },
          "& .MuiListItemIcon-root": {
            minWidth: "28px",
            "& .MuiSvgIcon-root ": {
              marginBottom: "3px",
            },
          },
        }}
      >
        {selectedTab === 0 &&
          competition.status !== "running" && [
            <Tooltip
              title={
                moment
                  .tz(competition?.startDatetime, loginUser.timezone)
                  .subtract(15, "minutes")
                  .isSameOrBefore(moment.tz(undefined, loginUser.timezone))
                  ? "Competition can't be edited 15 minutes before its start time."
                  : ""
              }
              key="Tooltip"
            >
              <div>
                <MenuItem
                  onClick={handleCompetitionEdit}
                  key="edit"
                  disabled={moment
                    .tz(competition?.startDatetime, loginUser.timezone)
                    .subtract(15, "minutes")
                    .isSameOrBefore(moment.tz(undefined, loginUser.timezone))}
                >
                  <ListItemIcon>
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText>Edit</ListItemText>
                </MenuItem>
              </div>
            </Tooltip>,
            <MenuItem onClick={handleCompetitionAssign} key="assign">
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText>Assign</ListItemText>
            </MenuItem>,
            <MenuItem onClick={handleCompetitionDelete} key="delete">
              <ListItemIcon>
                <DeleteForeverIcon />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>,
          ]}
        {selectedTab === 0 && competition.status === "running" && (
          <MenuItem onClick={handleCompetitionEnd} key="end">
            <ListItemIcon>
              <DeleteForeverIcon />
            </ListItemIcon>
            <ListItemText>End Competition</ListItemText>
          </MenuItem>
        )}
        {selectedTab === 1 && [
          <MenuItem onClick={handleCompetitionEdit} key="edit">
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>,
          <MenuItem onClick={handleCompetitionActivate} key="activate">
            <ListItemIcon>
              <CommitIcon />
            </ListItemIcon>
            <ListItemText>Activate</ListItemText>
          </MenuItem>,
          <MenuItem onClick={handleCompetitionAssign} key="assign">
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText>Assign</ListItemText>
          </MenuItem>,
          <MenuItem onClick={handleCompetitionDelete} key="delete">
            <ListItemIcon>
              <DeleteForeverIcon />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>,
        ]}
        {selectedTab === 2 &&
          competition?.status !== "running" && [
            <MenuItem onClick={handleCompetitionCopy} key="copy">
              <ListItemIcon>
                <ContentCopyIcon />
              </ListItemIcon>
              <ListItemText>Make a Copy</ListItemText>
            </MenuItem>,
            <MenuItem onClick={handleRunCompetition} key="run">
              <ListItemIcon>
                <PlayCircleFilledWhiteIcon />
              </ListItemIcon>
              <ListItemText>Run Again</ListItemText>
            </MenuItem>,
          ]}
        {selectedTab === 2 &&
          competition?.status === "running" && [
            <MenuItem onClick={handleCompetitionCopy} key="copy">
              <ListItemIcon>
                <ContentCopyIcon />
              </ListItemIcon>
              <ListItemText>Make a Copy</ListItemText>
            </MenuItem>,
          ]}
        {selectedTab === 2 &&
          competition?.status === "closed" && [
            <MenuItem onClick={handleRemoveCompetitionFromFavorites} key="delete">
              <ListItemIcon>
                <DeleteForeverIcon />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>,
          ]}
      </Menu>
    </>
  );
}

export default CompetitionActions;
